/* eslint-disable */
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';

const APPROX_CLASS = 'distance-from-you__approx';

/** Approximate prefix for distance line — isolated so it uses body font, not a fallback glyph */
export function DistanceFromYouApprox() {
  return (
    <span className={APPROX_CLASS} aria-hidden="true">
      ~
    </span>
  );
}

/** Distance label for React (start / startMany headers) */
export default function DistanceFromYouLabel({ km, className, Tag = 'span' }) {
  const { t } = useTranslation();
  return (
    <Tag className={className}>
      <DistanceFromYouApprox />
      {t('map.distanceFromYou', { km })}
    </Tag>
  );
}

/** Distance label HTML for MapLibre popups */
export function distanceFromYouHtml(km) {
  return `<span class="${APPROX_CLASS}" aria-hidden="true">~</span>${i18n.t('map.distanceFromYou', { km })}`;
}
